import App from './App.vue';

export default {
  path: '/CDS_VF_RefugeTotalList',
  name: 'CDS_VF_RefugeTotalList',
  component: App,
  meta: {
    pageProperty: {
      title: '避難所集計',
      controller: 'CDS_CTR_RefugeTotalList',
    },
  },
};
